import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgImageIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "#323338",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Path_6596",
		"data-name": "Path 6596",
		d: "M22.551,20.378V5.172A2.179,2.179,0,0,0,20.378,3H5.172A2.179,2.179,0,0,0,3,5.172V20.378a2.179,2.179,0,0,0,2.172,2.172H20.378A2.179,2.179,0,0,0,22.551,20.378ZM9.408,14.926l2.281,2.748,3.367-4.334a.545.545,0,0,1,.869.011l3.812,5.083a.543.543,0,0,1-.434.869H6.28a.541.541,0,0,1-.424-.88l2.7-3.476A.536.536,0,0,1,9.408,14.926Z",
		transform: "translate(-3 -3)"
	})
});
export { SvgImageIcon as ReactComponent };
